import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

export const SetCaseContextBadge = ({
  isDone,
  ...props
}: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      resultTexts={{
        loading: 'Updating case context…',
        done: 'Case context updated',
        error: 'Error updating case context',
      }}
    />
  );
};
